import React from 'react';
// import './Footer.css';
import { Link } from 'react-router-dom';

// import logo from "../images/logojewellers.jpg";
import MRINDIANCODER from "../images/mr.indiancoder.jpg";
import "./Footer.css";
import ReactWhatsapp from "react-whatsapp";
function Footer() {
  return (


    <div className="garmentnadia">
      <br></br>
      <br />
      {/* <div class="p-3 mb-0 bg-dark text-maroon"> */}

      <div className="album py-3">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <h6 style={{ color: "maroon" }}>OFFICE ADDRESS</h6>
              <hr />

              <ul class="list-unstyled">

                <h6 style={{ color: "maroon" }} className="card-text mb-3"> <b>ANEEK TEXTILES</b></h6>
                <h5 className='mb-2'>Register Office</h5>
                <p style={{ color: "maroon" }} class="card-text mb-1"><small>Aistala, Ranaghat, Nadia, Pin-741201, WB |  India</small></p>
              
                <a href='tel: 9064837572'>+91 9064837572</a> / <a href='tel: 7501445023'>7501445023</a>
<br/>
                <a href='tel:+91 9091500550'>+91 9091500550</a> 


       
              </ul>
            </div>

            <div class="col-md-3">
              <h6 style={{ color: "maroon" }}>Quick Link</h6>
              <hr />
              <ul class="list-unstyled">


                <a style={{ color: "maroon" }} href="contact-us">
                  <li style={{ color: "maroon" }} class="mb-2"><a ><small>Contact us</small></a></li></a>
    

                  <a style={{ color: "maroon" }} href="about-us">
                  <li style={{ color: "maroon" }} class="mb-2"><a ><small>About us</small></a></li></a>
                  <a style={{ color: "maroon" }} href="showroom-photo">
                  <li style={{ color: "maroon" }} class="mb-2"><a ><small>Our Showroom Explore</small></a></li></a>



              </ul>

            </div>
            <div class="col-md-3">

              <h6 style={{ color: "maroon" }}>Legal Link</h6>
              <hr />

              <ul class="list-unstyled">
                <a href='terms' style={{ color: "maroon" }} >
                  <li style={{ color: "maroon" }} class="mb-2"><small>Terms & Conditions</small></li></a>
                <a href='privacy-policy' style={{ color: "maroon" }} >
                  <li style={{ color: "maroon" }} class="mb-2"><small>Privacy Policy</small></li></a>
       
              </ul>

              <br />



            </div>
            <div class="col-md-2">
              <h6 style={{ color: "maroon" }}>Social Link</h6>
              <hr />
              <ul class="list-unstyled">
                <li class="mb-2"> <a style={{ color: "blue" }} href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" style={{ color: "blue" }} class="bi bi-facebook" viewBox="0 0 16 16">
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                  </svg> <small> Facebook</small></a> </li>

                <li class="mb-2"> <a style={{ color: "red" }} href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" style={{ color: "red" }} class="bi bi-youtube" viewBox="0 0 16 16">
                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                  </svg> <small> Youtube</small></a> </li>






              </ul>

            </div>
          </div>
        </div>
      </div>

      <div class="album py-0">
        <div class="container">

          <div class="row">
        
 <div className="col-md-4">
  </div>


            <div className="col-md-4">
             
              <p style={{ color: "maroon" }}> Copyright © 2025, ANEEK TEXTILES</p>
             
            </div>
             <div className="col-md-4">
              <small style={{ color: "maroon" }}> Developed & Design By: <a style={{ color: "maroon" }} href="https://www.mrindiancoder.com/" target="_blank" rel="noopener noreferrer"> MR. INDIAN CODER</a> </small>
              <small>  <a href="https://www.mrindiancoder.com/" target="_blank" rel="noopener noreferrer"> </a> </small>
              <br />
              <a href="https://www.mrindiancoder.com/" target="_blank" rel="noopener noreferrer"> <img src={MRINDIANCODER} width="60" height="22" alt="mr.indiancoder" /> </a>
            </div>
           

          </div>
        </div>
      </div>
      <br />

    </div>
    //  </div>



  );
}
export default Footer;